/* eslint-disable arrow-parens */
import { useCallback, useState, useEffect, useContext, Suspense } from "react";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../constants/caption/dashboardHeader";
import { UIContext } from "../../../../../../contexts";
import { LINK } from "../../../../../../config/config";
import { url, port } from "../../../../../../config/config";
import axios from "axios";
import { dateTimeZoneConverter, timeConverter } from "../../../../../../utils/commonFunctions/date";
import CustomAddNoteDialog from "../../../../../shared/dialogs/customAddNoteDialog/CustomAddNoteDialog";
import { CustomDialog } from "../../../../../shared";

// meterial ui imports
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import EventIcon from "@material-ui/icons/Event";
import WatchLaterIcon from "@material-ui/icons/WatchLater";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import { Avatar, Grid, Paper, Tooltip, IconButton, TextareaAutosize, makeStyles, Button } from "@material-ui/core";

import "./noteDetails.css";
import "./scroll.css";
import { trackPromise } from "react-promise-tracker";
import useRouteParam from "../../../../../../hooks/useRouteParam";

const FormStyles = makeStyles(() => ({
	textarea: {
		width: "100%"
	}
}));

// eslint-disable-next-line react/prop-types
const NoteDetails = ({ member, setCountNotes }) => {
	// ------------------------------------------------------------------------------------------------
	// ---------------------------------------------- STATES ------------------------------------------
	// console.log("member", member);
	// eslint-disable-next-line react/prop-types
	const { SSN, group_number } = member;
	const [notes, setNotes] = useState([]);
	const [hasNoteLoaded, setHasNoteLoaded] = useState(false);
	const [addNewNote, setAddNewNote] = useState("");
	const [selectedNoteIds, setSelectedNoteIds] = useState([]);
	const [deleteNoteId, setDeleteNoteId] = useState("");
	const querySSN = useRouteParam("qs");
	const queryGroupNumber = useRouteParam("gn");

	// ------------------------------------------------------------------------------------------------
	// ---------------------------------------------- OTHER CONSTANTS----------------------------------

	const classes = FormStyles();
	const { setDashboardHeader } = useContext(UIContext);

	// -------------------------------- (open dialog) --------------------------------------
	const [customAddNotesDialogProps, setCustomAddNotesDialogProps] = useState({
		openDialog: false,
		title: "Add New Note",
		actions: [
			{
				label: "Cancel",
				name: "cancel",
				callback: () => {
					setCustomAddNotesDialogProps(Object.assign({}, customAddNotesDialogProps, { openDialog: false }));
				}
			},
			{
				label: "Submit",
				name: "submit",
				callback: () => null
			}
		]
	});

	// --------------------------------- ( delete open dialog ) ----------------------------------
	const [customDeleteNotesDialogProps, setCustomDeleteNotesDialogProps] = useState({
		openDialog: false,
		title: "Do you want to delete this note ?",
		actions: [
			{
				label: "Cancel",
				name: "cancel",
				callback: () => {
					setCustomDeleteNotesDialogProps(
						Object.assign({}, customDeleteNotesDialogProps, { openDialog: false })
					);
				}
			},
			{
				label: "Delete",
				name: "reject",
				callback: () => {
					handleDeleteNotes(deleteNoteId);
				}
			}
		]
	});

	// ----------------------------------------------------------------------------------------------------------------
	// ---------------------------------------------- EDIT BUTTON (FUNCTION) ------------------------------------------

	const handleEditChange = (id) => {
		setSelectedNoteIds((selectedNoteIds) => [...selectedNoteIds, id]);
	};

	const handleChangenote = (event, id) => {
		const { value } = event.target;
		//console.log(event.target.value);
		for (var i = 0; i < notes.length; i++) {
			if (notes[i]._id === id) {
				notes[i] = Object.assign({}, notes[i], { note: value });
				setNotes(notes);
			}
		}
	};

	const handleAddNewNoteChange = useCallback(
		(event) => {
			const { value } = event.target;
			setAddNewNote(value);
		},
		[setAddNewNote]
	);

	// ------------------------------------------------------------------------------------------------------------------
	// ---------------------------------------------- SAVE BUTTON (FUNCTION) ------------------------------------------

	const handleSaveChanges = (_id) => {
		const _selectedNoteIds = selectedNoteIds.filter((eachId) => eachId !== _id);
		setSelectedNoteIds(Object.assign([], _selectedNoteIds));

		const token = localStorage.getItem("@jwt");
		const api_url = `${LINK}/notes`;
		for (let noteIdx = 0; noteIdx < notes.length; noteIdx++) {
			if (notes[noteIdx]._id === _id) {
				const payload = {
					_id: notes[noteIdx]._id,
					note: notes[noteIdx].note
				};
				// console.log("Updated Notes ", notes[noteIdx].note, "\n\npayload ----", payload);
				axios
					.patch(api_url, payload, {
						headers: {
							Authorization: `Bearer ${token}`
						}
					})
					.then((response) => {
						const _notes = response.data.result;
						setNotes(Object.assign([], _notes));
						setCountNotes(_notes.length);
					});
			}
		}
	};

	// ------------------------------------------------------------------------------------------------------------------
	// ---------------------------------------------- DELETE BUTTON (FUNCTION) ------------------------------------------

	const handleDeleteNotes = useCallback(
		(_id) => {
			const JWT_LOC = localStorage.getItem("@jwt");
			const DELETE_API = `${LINK}/notes/delete/${_id}`;
			axios
				.delete(DELETE_API, {
					headers: {
						Authorization: `Bearer ${JWT_LOC}`
					}
				})
				.then((res) => {
					const newData = res.data.result;
					// console.log("After Deletion --------------", newData);
					setNotes(newData);
					setCountNotes(newData.length);
				})
				.catch((err) => {
					// console.log(err.message);
				});
		},
		[setCountNotes]
	);

	// ----------------------------------------------------------------------------------------------------------------
	// ---------------------------------------------- GET NOTES (FUNCTION) --------------------------------------------

	const getNotes = useCallback(
		async (group_number, SSN) => {
			const JWT_LOC = localStorage.getItem("@jwt");
			const GET_API = `${LINK}/notes`;
			const filter = {
				SSN,
				group_number
			};
			// console.log("filter", filter);
			const response = await trackPromise(
				axios.get(GET_API, {
					headers: {
						Authorization: `Bearer ${JWT_LOC}`
					},
					params: filter
				})
			);
			setNotes(response.data.result);
			setCountNotes(response.data.result.length);
			setHasNoteLoaded(true);
		},
		[setCountNotes]
	);

	const handleAddNoteSubmitClick = useCallback(async () => {
		const JWT_LOC = localStorage.getItem("@jwt");
		const payload = {
			SSN: SSN,
			group_number: group_number,
			note: addNewNote
		};
		const api_url = `${url}:${port}` + "/api/v1/notes";
		const response = await trackPromise(
			axios.post(api_url, payload, { headers: { Authorization: `Bearer ${JWT_LOC}` } })
		);
		if (response.status === 200) {
			setNotes(Object.assign([], response.data.result));
			setCountNotes(response.data.result.length);
		}

		setCustomAddNotesDialogProps(Object.assign({}, customAddNotesDialogProps, { openDialog: false }));
	}, [SSN, addNewNote, customAddNotesDialogProps, group_number, setCountNotes]);

	// -------------------------------------------------------------------------
	// ---------------------- Dialog Open Funtion (Add Notes) ------------------

	const handleOpenAddNoteDialogClick = useCallback(() => {
		setCustomAddNotesDialogProps(Object.assign({}, customAddNotesDialogProps, { openDialog: true }));
	}, [customAddNotesDialogProps]);

	const handleCloseAddNoteDialogClick = useCallback(() => {
		setCustomAddNotesDialogProps(Object.assign({}, customAddNotesDialogProps, { openDialog: false }));
	}, [customAddNotesDialogProps]);

	// -------------------------------------------------------------------------
	// ---------------------- Dialog Open Funtion (Delete Notes) ---------------

	const handleCloseDeleteNoteDialogClick = useCallback(() => {
		setCustomDeleteNotesDialogProps(Object.assign({}, customDeleteNotesDialogProps, { openDialog: false }));
	}, [customDeleteNotesDialogProps]);

	const handleOpenDeleteNoteDialogClick = useCallback(
		(id) => {
			// console.log("ID ---> 123", id, typeof id);
			// console.log("deleteNodeId inside ", deleteNoteId);
			// console.log("deleteNoteId", deleteNoteId);
			setCustomDeleteNotesDialogProps(
				Object.assign(
					{},
					{
						openDialog: true,
						title: "Do you want to delete this note ?",
						actions: [
							{
								label: "Cancel",
								name: "cancel",
								callback: () => {
									setCustomDeleteNotesDialogProps(
										Object.assign({}, customDeleteNotesDialogProps, { openDialog: false })
									);
								}
							},
							{
								label: "Delete",
								name: "reject",
								callback: () => {
									handleDeleteNotes(id);
									handleCloseDeleteNoteDialogClick();
									alert("Successfully deleted the notes");
								}
							}
						]
					}
				)
			);
		},
		[customDeleteNotesDialogProps, handleCloseDeleteNoteDialogClick, handleDeleteNotes]
	);

	// ------------------------------------------------------------------------
	// ---------------------------- USE EFFECT --------------------------------

	useEffect(() => {
		if (querySSN && queryGroupNumber) {
			getNotes(queryGroupNumber, querySSN);
		}
	}, [getNotes, queryGroupNumber, querySSN]);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.note_details);
	}, [setDashboardHeader, deleteNoteId]);

	// ------------------------------------------------------------
	// ---------------------- MAIN RENDER -------------------------

	return (
		<>
			<Suspense fallback={<div />}>
				<CustomAddNoteDialog
					dialogProps={customAddNotesDialogProps}
					handleClose={handleCloseAddNoteDialogClick}
					handleAddNewNoteChange={handleAddNewNoteChange}
					handleAddNoteSubmitClick={handleAddNoteSubmitClick}
				/>
			</Suspense>
			<Suspense fallback={<div />}>
				<CustomDialog
					dialogProps={customDeleteNotesDialogProps}
					handleClose={handleCloseDeleteNoteDialogClick}
				/>
			</Suspense>
			<div className="notes-details-container">
				<div className="pf-title">Notes</div>
				<div className="pf-action-button-container" id="pf-action-button-container">
					{/* <Button className="button-green" variant="contained">
					<span className="button-label-with-icon">Add Notes</span>
					<span>
						<NoteAddIcon className="button-icon" />
					</span>
				</Button> */}
					<Button className="button-green" variant="contained" onClick={handleOpenAddNoteDialogClick}>
						<span className="button-label-with-icon">Add Notes</span>
						<span>
							<NoteAddIcon className="button-icon" />
						</span>
					</Button>
				</div>
				{hasNoteLoaded === true || notes.length !== 0 ? (
					<div className="notes-container">
						<Grid container spacing={1} className=" grid-container">
							{notes.map((eachItem, index) => {
								const { _id, note, updatedAt, group_owner } = eachItem;
								return (
									<Paper
										className="pf-paper-container notes-paper-container"
										elevation={3}
										variant="outlined"
										key={index}
									>
										<Grid
											item
											xs={12}
											sm={12}
											md={12}
											lg={12}
											xl={12}
											className="notes-header-container"
										>
											<Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="notes-header-id">
												<Avatar>{index + 1}</Avatar>
											</Grid>
											<Grid
												item
												xs={6}
												sm={6}
												md={6}
												lg={6}
												xl={6}
												className="notes-header-details"
											>
												<Grid
													item
													xs={4}
													sm={4}
													md={4}
													lg={4}
													xl={4}
													className="notes-person-details"
												>
													<span>
														<AccountCircleIcon className="header-person-icon" />
													</span>
													<span className="header-person-label">
														By{" "}
														{group_owner
															? group_owner.first_name + " " + group_owner.last_name
															: null}
													</span>
												</Grid>
												<Grid
													item
													xs={4}
													sm={4}
													md={4}
													lg={4}
													xl={4}
													className="notes-date-details"
												>
													<span>
														<EventIcon className="header-date-icon" />
													</span>
													<span className="header-date-label">
														{dateTimeZoneConverter(updatedAt)}
													</span>
												</Grid>
												<Grid
													item
													xs={4}
													sm={4}
													md={4}
													lg={4}
													xl={4}
													className="notes-time-details"
												>
													<span>
														<WatchLaterIcon className="header-time-icon" />
													</span>
													<span className="header-time-label">
														{timeConverter(updatedAt)}
													</span>
												</Grid>
											</Grid>
										</Grid>
										{selectedNoteIds.includes(_id) ? (
											<TextareaAutosize
												className={classes.textarea}
												defaultValue={note}
												onChange={(event) => handleChangenote(event, _id)}
											/>
										) : note.length > 200 ? (
											<div className="notes-description-container">{note}</div>
										) : (
											<div className="notes-description-container-small">
												<div className="notes-description-text-small">{note}</div>
											</div>
										)}
										{/* {selectedNoteIds.includes(_id) ? (
									<TextareaAutosize
										className={classes.textarea}
										defaultValue={note}
										onChange={(event) => handleChangenote(event, _id)}
									/>
								) : note.length > 200 ? (
									<div className="notes-note-container">{note}</div>
								) : (
									<div className="notes-note-container-small">
										<div className="notes-note-text-small">{note}</div>
									</div>
								)} */}
										<div className="notes-action-button-container">
											{selectedNoteIds.includes(_id) ? (
												// ------------------------------------------------------------------
												// ------------------------------ SAVE ------------------------------
												<Tooltip title="Save" enterDelay={500} leaveDelay={200} arrow>
													<IconButton>
														<SaveIcon onClick={() => handleSaveChanges(_id)} />
													</IconButton>
												</Tooltip>
											) : (
												// ------------------------------------------------------------------
												// ------------------------------ EDIT ------------------------------
												<Tooltip title="Edit" enterDelay={500} leaveDelay={200} arrow>
													<IconButton>
														<EditIcon onClick={() => handleEditChange(_id)} />
													</IconButton>
												</Tooltip>
											)}
											{/* ------------------------------------------------------------------
									    ------------------------------ DELETE-- -------------------------- */}
											<Tooltip title="Delete" enterDelay={500} leaveDelay={200} arrow>
												<IconButton>
													<DeleteIcon onClick={() => handleOpenDeleteNoteDialogClick(_id)} />
												</IconButton>
											</Tooltip>
										</div>
									</Paper>
								);
							})}
						</Grid>
					</div>
				) : (
					<div className="notes-container pf-label-text"> No note to show</div>
				)}
			</div>
		</>
	);
};

export default NoteDetails;
